import React from 'react';
import logo from 'assets/images/msys.png';
import PropTypes from 'prop-types';
import AppBrand from './Brand';

function Footer({ type }) {
  if (type === 'public') {
    return (
      <div className="sm:text-left text-center">
        <span className="text-xxs text-gray-500">Powered by</span>
        <img
          className="h-6 w-auto mx-auto sm:-mx-0"
          src={logo}
          alt="scorebox"
        />
        <span className="text-xxs text-gray-500">Version: 2.0</span>
      </div>
    );
  }
  return (
    <div className="bg-white p-7">
      <div className="container mx-auto flex items-center justify-between">
        <div>
          <AppBrand className="h-10 w-auto" />
          <span className="text-xs font-ligth text-gray-500">
            Copyright &copy; Manila Local Government System. All Rights Reserved
          </span>
          <div className="block sm:hidden border-t mt-2 pt-2">
            <span className="text-xxs text-gray-500">Powered by</span>
            <img className="h-5 w-auto" src={logo} alt="scorebox" />
          </div>
        </div>
        <div className="hidden sm:block">
          <span className="text-xxs text-gray-500">Powered by</span>
          <img className="h-5 w-auto" src={logo} alt="scorebox" />
        </div>
      </div>
    </div>
  );
}

Footer.defaultProps = {
  type: 'public',
};

Footer.propTypes = {
  type: PropTypes.string,
};

export default Footer;
